import React from 'react'

const SvgFaucetFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20 17c1.333 1.264 2 2.264 2 3a2 2 0 11-4 0c0-.736.667-1.736 2-3zM3.5 8c.249 0 .455.229.493.53L4 8.631v6.736c0 .314-.181.575-.419.624L3.5 16h-1c-.249 0-.455-.229-.493-.53L2 15.369V8.632c0-.314.181-.575.419-.624L2.5 8h1zM13 6a1 1 0 011 1v1a2 2 0 012 2h2a4 4 0 014 4v1h-4v-1h-2a2 2 0 01-2 2h-4a2 2 0 01-2-2H7a1 1 0 01-1-1v-2a1 1 0 011-1h1a2 2 0 012-2V7a1 1 0 011-1h2zm1.526-4c.233 0 .426.177.466.41L15 2.5v1c0 .245-.168.45-.389.492L14.526 4H9.474a.482.482 0 01-.466-.41L9 3.5v-1c0-.245.168-.45.389-.492L9.474 2h5.052z'
    />
  </svg>
)

export default SvgFaucetFilled
